/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum N2MajorApplicationStatus {
    Unknown = "Unknown",
    Declined = "Declined",
    Cancelled = "Cancelled",
    InProgress = "InProgress",
    Aproved = "Aproved",
    NotFound = "NotFound",
}
